import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49195e15"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_2 = { class: "apply-main" }
const _hoisted_3 = { class: "result-success" }
const _hoisted_4 = { class: "result-img" }
const _hoisted_5 = { class: "result-title" }
const _hoisted_6 = {
  key: 0,
  class: "title"
}
const _hoisted_7 = {
  key: 1,
  class: "title"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "您可以复制下载地址，发送给您的渠道进行推广~", -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("增加新渠道")
const _hoisted_10 = ["title"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("修改渠道名称")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("复制下载链接")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select-tips" }, "* 请输入或选择1~100之间的数字", -1))
const _hoisted_14 = /*#__PURE__*/_createTextVNode("无安装界面包")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("正常安装包")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("确定添加")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定修改")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tips = _resolveComponent("Tips")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_MainLayout = _resolveComponent("MainLayout")!

  return (_openBlock(), _createBlock(_component_MainLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_Tips, { msg: "添加好新渠道后，您可以复制下载地址，发送给您的渠道进行推广~" }),
      _createVNode(_component_el_form, {
        ref: "applyFormRef",
        inline: true,
        model: _ctx.applyForm,
        class: "demo-form-inline",
        rules: _ctx.applyFormRules
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "业务名称:",
            prop: "soft_type"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.applyForm.soft_type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.applyForm.soft_type) = $event)),
                placeholder: "请选择",
                onChange: _ctx.changeChannel
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.channelSoftInfos, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.softid,
                      label: item.softname,
                      value: item.softid
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit()))
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_image, {
              src: _ctx.softImg,
              alt: "",
              srcset: ""
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.applyTableData.length > 0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.softName) + "申请成功", 1))
              : _createCommentVNode("", true),
            (_ctx.applyTableData.length === 0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, "申请" + _toDisplayString(_ctx.softName) + "推广软件", 1))
              : _createCommentVNode("", true),
            _hoisted_8,
            _createVNode(_component_el_button, {
              type: "success",
              size: "medium",
              onClick: _ctx.addNewApply
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createVNode(_component_el_table, {
          data: _ctx.applyTableData,
          style: {"width":"100%"},
          stripe: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "url",
              label: "下载地址（每个渠道分配一个计费id，如：22467645）",
              width: "330"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", {
                  class: "url-overflow",
                  title: scope.row.url
                }, _toDisplayString(scope.row.url), 9, _hoisted_10)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "accid",
              label: "计费id"
            }),
            _createVNode(_component_el_table_column, {
              prop: "tag",
              label: "渠道名称"
            }),
            _createVNode(_component_el_table_column, {
              prop: "desc",
              label: "安装包类型"
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "260"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  size: "mini",
                  type: "success",
                  onClick: ($event: any) => (_ctx.modifyApply(scope.$index, scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_el_button, {
                  size: "mini",
                  type: "success",
                  onClick: ($event: any) => (_ctx.copyUrl(scope.$index, scope.row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogAddFormVisible,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogAddFormVisible) = $event)),
        title: "增加新渠道"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "addApplyFormRef",
            model: _ctx.addApplyForm,
            rules: _ctx.addApplyFormRules,
            "label-position": "right",
            "label-width": "150px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "设置子渠道个数",
                prop: "count"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.addApplyForm.count,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addApplyForm.count) = $event)),
                    placeholder: "请输入1~100之间的数字",
                    "default-first-option": "",
                    filterable: "",
                    "allow-create": ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countData, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _hoisted_13,
              (!(_ctx.applyForm.soft_type === 0 || _ctx.applyForm.soft_type === 4))
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "设置子渠道类型",
                    prop: "accid_type"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.addApplyForm.accid_type,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addApplyForm.accid_type) = $event)),
                        label: "1"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_el_radio, {
                        modelValue: _ctx.addApplyForm.accid_type,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addApplyForm.accid_type) = $event)),
                        label: "3"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addApplySecondary()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogchangeFormVisible,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.dialogchangeFormVisible) = $event)),
        title: "修改子渠道名称"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form, {
            ref: "changeApplyFormRef",
            model: _ctx.changeApplyForm,
            rules: _ctx.changeApplyFormRules,
            "label-position": "right",
            "label-width": "150px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "计费ID",
                prop: "count"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.changeApplyForm.accid,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.changeApplyForm.accid) = $event)),
                    placeholder: "Please input",
                    disabled: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "该渠道名称",
                prop: "count"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.changeApplyForm.tag,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.changeApplyForm.tag) = $event)),
                    placeholder: "Please input"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeApplySecondary()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}